// CNPJ do cadastro de clientes: máscara 00.000.000/0000-00 e conferência dos
// dois dígitos verificadores (módulo 11). Só numérico — o CNPJ alfanumérico
// da Receita (a partir de 07/2026 para inscrições novas) não é aceito aqui.

export const somenteDigitosCnpj = (v) => String(v || '').replace(/\D/g, '').slice(0, 14);

// Máscara progressiva, para usar no onChange do campo.
export const mascararCnpj = (v) => {
  const d = somenteDigitosCnpj(v);
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`;
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
};

const digitoVerificador = (base) => {
  const pesos = base.length === 12
    ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
    : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const soma = base.split('').reduce((s, n, i) => s + Number(n) * pesos[i], 0);
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
};

export const cnpjValido = (v) => {
  const d = String(v || '').replace(/\D/g, '');
  if (d.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(d)) return false; // 00.000.000/0000-00, 11.111.111/1111-11...
  const dv1 = digitoVerificador(d.slice(0, 12));
  const dv2 = digitoVerificador(d.slice(0, 12) + dv1);
  return d.endsWith(`${dv1}${dv2}`);
};

// Para documentos: devolve o CNPJ formatado, ou '' se não houver.
export const cnpjFormatado = (v) => (somenteDigitosCnpj(v) ? mascararCnpj(v) : '');
